import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Biography from "./pages/Biography";
import Ebook from "./pages/Ebook";
import Slogans from "./pages/Slogans";
import FunctionPage from "./pages/FunctionPage ";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/Notfound";
import Loader from "./components/Loader";
import "./styles/main.scss";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <Router>
      <ScrollToTop /> {/* 🔥 THIS FIXES YOUR ISSUE */}
      <Header />

      <main className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/biography" element={<Biography />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/ebook" element={<Ebook />} />
          <Route path="/slogans" element={<Slogans />} />
          <Route path="/functions" element={<FunctionPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </Router>
  );
}

export default App;